import { graphql } from '../../../graphql/generated';

export const NEWS_CONFIRMATION_MODAL_QUERY = graphql(`
  query NewsConfirmationModal($doctorId: ID!) {
    relevantNews(doctorId: $doctorId) {
      ...NewsList_News
    }
  }
`);
